export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./card.vue?vue&type=template&id=183bd2fd&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/card/card.vue?vue&type=template&id=183bd2fd&
// module id = 1228
// module chunks = 0